/**
 * The entry point of a public preview link: which service the link opens. A project with several apps (a web app and an
 * admin, two frontends) lets the person pick one; with one service there is nothing to pick.
 */

/** The service folders under `services/`, from a directory listing (hidden folders and files left out). */
export function serviceNames(entries) {
  return (entries || [])
    .filter((entry) => entry && entry.type === 'directory' && entry.name && !entry.name.startsWith('.'))
    .map((entry) => entry.name)
    .sort((a, b) => a.localeCompare(b));
}

/** The service the link opens by default: the one being looked at, else `app`, else the first. '' when there are none. */
export function defaultEntry(names, preferred) {
  if (!names.length) { return preferred || ''; }
  if (preferred && names.includes(preferred)) { return preferred; }
  return names.includes('app') ? 'app' : names[0];
}
